import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "../../config/urls";
import { toastr } from "react-redux-toastr";
import ReactTable from "react-table";
import { Link, withRouter } from "react-router-dom";
var SuggestionsUpdates = /** @class */ (function (_super) {
    tslib_1.__extends(SuggestionsUpdates, _super);
    function SuggestionsUpdates(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            searching: false,
            suggestions: [],
            page: _this.props.history.location.search.split('=')[1] ? Number(_this.props.history.location.search.split('=')[1]) - 1 : 0,
            pageSize: 20,
        };
        return _this;
    }
    SuggestionsUpdates.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.history.action === "POP") {
            var prevState = localStorage.getItem("suggestions-update-state");
            if (prevState) {
                var parsePrevState = JSON.parse(prevState);
                this.setState(tslib_1.__assign({}, parsePrevState, { page: this.props.history.location.search.split('=')[1] }), function () {
                    _this.getSuggestions();
                });
            }
            else {
                this.getSuggestions();
            }
        }
        else {
            this.getSuggestions();
        }
        localStorage.removeItem("suggestions-update-state");
    };
    SuggestionsUpdates.prototype.componentWillUnmount = function () {
        localStorage.setItem("suggestions-update-state", JSON.stringify({
            page: this.state.page,
            pageSize: this.state.pageSize,
        }));
    };
    SuggestionsUpdates.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.props.history.action === "POP") {
            this.setState({ page: this.props.history.location.search.split('=')[1] }, function () {
                _this.getSuggestions();
            });
        }
    };
    SuggestionsUpdates.prototype.render = function () {
        var _this = this;
        var columns = [{
                Header: '#',
                accessor: 'id',
                width: 70,
                style: { textAlign: 'center' }
            }, {
                Header: 'ID пользователя',
                sortable: false,
                accessor: 'user_id',
            }, {
                Header: 'ID предложения',
                sortable: false,
                accessor: 'suggestion_id',
            }, {
                Header: 'Управление',
                sortable: false,
                width: 150,
                style: { textAlign: 'center' },
                Cell: function (props) {
                    return (React.createElement("div", { className: "btn-group" },
                        React.createElement("button", { onClick: _this.changeStatus.bind(_this, props.row.id), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-thumbs-up" })),
                        React.createElement(Link, { to: "/suggestions-update/" + props.row.id, className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-eye" })),
                        React.createElement("button", { onClick: _this.removeSuggestion.bind(_this, props.row.id), type: "button", className: "btn btn-sm btn-danger btn-flat" },
                            React.createElement("i", { className: "fa fa-trash" }))));
                }
            }];
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-xs-2 pull-left" },
                    React.createElement("h3", null, "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439"))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(ReactTable, { previousText: '\u041D\u0430\u0437\u0430\u0434', nextText: '\u0412\u043F\u0435\u0440\u0435\u0434', loadingText: 'Loading...', noDataText: '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E', pageText: '\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430', ofText: '\u0438\u0437', rowsText: '\u0441\u0442\u0440\u043E\u043A', page: this.state.page, pages: Math.ceil(this.state.pages / this.state.pageSize), loading: this.state.loading, minRows: 1, manual: true, onPageChange: this.nextPage.bind(this), onSortedChange: this.onSort.bind(this), onPageSizeChange: this.onPageSize.bind(this), data: this.state.suggestions, columns: columns })))));
    };
    SuggestionsUpdates.prototype.getSuggestions = function () {
        var _this = this;
        this.setState({ loading: true });
        var searchString = 'page=' + (this.state.page + 1) + '&limit=' + this.state.pageSize;
        axios.get(API_URL + '/suggestion/updates?' + searchString, {
            headers: { 'Authorization': this.props.auth_token }
        }).then(function (resp) {
            _this.setState({
                suggestions: resp.data.data ? resp.data.data : [], pages: resp.data.meta.total,
                loading: false
            });
        }).catch(function (error) {
            if (error.response && error.response.status === 403) {
                toastr.error('Ошибка', 'У Вас недостаточно прав');
            }
        });
    };
    SuggestionsUpdates.prototype.nextPage = function (page) {
        var _this = this;
        this.setState({ page: page }, function () {
            _this.getSuggestions();
            _this.addParamToUrl(page + 1);
        });
    };
    SuggestionsUpdates.prototype.onSort = function (sort) {
        var _this = this;
        this.setState({ sort: sort[0].desc ? '-' + sort[0].id : sort[0].id }, function () { return _this.getSuggestions(); });
    };
    SuggestionsUpdates.prototype.onPageSize = function (pageSize) {
        var _this = this;
        this.setState({
            pageSize: pageSize,
            page: 0,
        }, function () {
            _this.getSuggestions();
            _this.addParamToUrl(_this.state.page + 1);
        });
    };
    SuggestionsUpdates.prototype.removeSuggestion = function (id) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите удалить запрос?');
        if (result) {
            axios.delete(API_URL + '/suggestion/delete-update/' + id, {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getSuggestions();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    SuggestionsUpdates.prototype.changeStatus = function (id) {
        var _this = this;
        var result = confirm('Вы уверены, что хотите подтвердить изменение предложения?');
        if (result) {
            axios.post(API_URL + '/suggestion/approve-update/' + id, {}, {
                headers: { 'Authorization': this.props.auth_token },
            }).then(function () {
                _this.getSuggestions();
            }).catch(function (e) {
                if (e.response.status === 403) {
                    toastr.error('Ошибка', 'У Вас недостаточно прав');
                }
                if (e.response.data.code === 406 || e.response.data.code === 409) {
                    for (var i in e.response.data.errors) {
                        if (e.response.data.errors.hasOwnProperty(i)) {
                            toastr.error('Ошибка', e.response.data.errors[i]);
                        }
                    }
                }
            });
        }
    };
    SuggestionsUpdates.prototype.addParamToUrl = function (param) {
        var url = '?page=' + param;
        this.props.history.push(url);
        return true;
    };
    return SuggestionsUpdates;
}(React.Component));
export default withRouter(connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(SuggestionsUpdates));



//////////////////
// WEBPACK FOOTER
// ./src/views/suggestionsupdates/index.tsx
// module id = 550
// module chunks = 0